import { CONST } from "./CONST";
import { COMPANY } from "@constants/company-data";

/**
 * 설정 데이터
 */
export const PreferenceData: any = {
  // 골조 설계
  connectedPipeExtraLength: {
    label: "연결형 파이프 설치시 여분 길이",
    desc: "가로대, 보 파이프 등 연결형 파이프의 설치를 용이하게 하기 위한 여분 길이입니다. 연결된 전체 길이에 추가해줍니다.",
    data: {
      min: 0.0,
      max: 5,
      step: 0.1,
      unit: CONST.UNIT_METER,
      prefix: "",
      desc: "",
    },
  },
  connectedPipePinWorkedFlag: {
    label: "연결형 파이프 핀가공",
    desc: "연결형 파이프를 핀가공 파이프로 설계할지, 파이프+연결핀으로 설계할지 선택합니다.",
    items: [
      {
        text: "핀가공 파이프",
        value: true,
      },
      {
        text: "파이프+연결핀",
        value: false,
      },
    ],
  },

  floorGirthPrismColumnWeldingFlag: {
    label: "바닥도리+각기둥 용접",
    desc: "바닥도리 파이프를 각기둥 파이프에 고정할때, 용접을 할지 U 클램프로 고정할지 선택합니다.",
    items: [
      {
        text: "용접하기",
        value: true,
      },
      {
        text: "U 클램프 사용",
        value: false,
      },
    ],
  },

  prismEndpieceWeldingFlag: {
    label: "각형 마구리 용접",
    desc: "각형 마구리를 설치할 때, 용접을 할지 부속(T 클램프, U 클램프, 십자 클램프)으로 고정할지 선택합니다.",
    items: [
      {
        text: "용접하기",
        value: true,
      },
      {
        text: "부속 사용",
        value: false,
      },
    ],
  },

  endpieceTholderFlag: {
    label: "마구리 T 고정구",
    desc: "마구리 샛기둥 파이프(중앙)와 서까래 파이프의 규격이 같은 경우, 일반 고정구를 대체하여 T 고정구를 사용할지 선택합니다.",
    items: [
      {
        text: "T 고정구 우선 사용",
        value: true,
      },
      {
        text: "일반 고정구 우선 사용",
        value: false,
      },
    ],
  },

  endpieceDiagonalTholderFlag: {
    label: "마구리 대각T 고정구",
    desc: "마구리 샛기둥 파이프(대각)와 서까래 파이프의 규격이 같은 경우, 일반 고정구를 대체하여 대각T 고정구를 사용할지 선택합니다.",
    items: [
      {
        text: "대각T 고정구 우선 사용",
        value: true,
      },
      {
        text: "일반 고정구 우선 사용",
        value: false,
      },
    ],
  },

  endpieceDiagonalTclampFlag: {
    label: "마구리 대각T 클램프",
    desc: "마구리 샛기둥 파이프(대각/48mm)와 서까래 파이프의 규격이 다른 경우, 일반 고정구를 대체하여 대각T 클램프를 사용할지 선택합니다.",
    items: [
      {
        text: "대각T 클램프 우선 사용",
        value: true,
      },
      {
        text: "일반 고정구 우선 사용",
        value: false,
      },
    ],
  },

  // 피복 설계
  extendFrontBackCoverFlag: {
    label: "앞뒷면 피복 연장",
    desc: "마구리 피복이 몸통과 별도로 견적될 때, 앞면과 뒷면의 피복을 길이방향으로 연장해서 견적합니다. 단, 폭이 같고, 길이가 40m미만인 경우에만 연장됩니다.",
    items: [
      {
        text: "연장하기",
        value: true,
      },
      {
        text: "연장하지 않기",
        value: false,
      },
    ],
  },

  reduceOpenedCoverWidthFlag: {
    label: "개폐된 기초 피복의 폭 줄임",
    desc: "기초 피복이 개폐된 경우, 개폐되지 않은 경우에 비해 피복의 폭 일부를 줄여서 딱 맞게 견적해줍니다.",
    items: [
      {
        text: "줄이기",
        value: true,
      },
      {
        text: "줄이지 않기",
        value: false,
      },
    ],
  },

  multiplyVinylWidthDecupleFlag: {
    label: "비닐 폭 계산 간격",
    desc: "비닐의 최종 폭 계산시, 10cm 간격 또는 5cm 간격으로 계산해줍니다.",
    items: [
      {
        text: "10cm 간격",
        value: true,
      },
      {
        text: "5cm 간격",
        value: false,
      },
    ],
  },

  addExtraShadenetLengthFlag: {
    label: "차광망 여분 길이",
    desc: "차광망이 길이 방향으로 줄어드는 것을 대비하여 추가하는 길이로, 길이에 따라 1~2m정도 여분을 추가해줍니다.",
    items: [
      {
        text: "여분 길이 추가하기",
        value: true,
      },
      {
        text: "여분 길이 추가하지 않기",
        value: false,
      },
    ],
  },
  cashmilonStyleOverlapLength: {
    label: "카시미론류 설치시 겹치는 길이",
    desc: "카시미론, 보온덮개 등이 설치 될때, 겹쳐서 설치되는 길이입니다.",
    data: {
      min: 0.0,
      max: 1,
      step: 0.1,
      unit: CONST.UNIT_METER,
      prefix: "",
      desc: "",
    },
  },
  pinWorkedNormalPadZincFlag: {
    label: "핀가공 일반 패드 [아연]",
    desc: "아연 규격의 일반 패드를 대체하여 핀가공된 패드를 사용할지 선택합니다.",
    items: [
      {
        text: "핀가공 사용",
        value: true,
      },
      {
        text: "핀가공 사용안함",
        value: false,
      },
    ],
  },
  pinWorkedNormalPadColorIronFlag: {
    label: "핀가공 일반 패드 [칼라 철]",
    desc: "칼라 철 규격의 일반 패드를 대체하여 핀가공된 패드를 사용할지 선택합니다.",
    items: [
      {
        text: "핀가공 사용",
        value: true,
      },
      {
        text: "핀가공 사용안함",
        value: false,
      },
    ],
  },
  padSpringMultFactor1: {
    label: "패드 스프링 설치 배율(%) [피복 1겹]",
    desc: "피복이 1겹 일때, 패드 스프링 설치 배율의 기본값을 설정합니다.",
    data: {
      min: 0.0,
      max: 200,
      step: 0.1,
      unit: CONST.UNIT_PERCENT,
      prefix: "",
      desc: "",
    },
  },
  padSpringMultFactor2: {
    label: "패드 스프링 설치 배율(%) [피복 2겹]",
    desc: "피복이 2겹 일때, 패드 스프링 설치 배율의 기본값을 설정합니다.",
    data: {
      min: 0.0,
      max: 200,
      step: 0.1,
      unit: CONST.UNIT_PERCENT,
      prefix: "",
      desc: "",
    },
  },
  padSpringMultFactor3: {
    label: "패드 스프링 설치 배율(%) [피복 3겹]",
    desc: "피복이 3겹 일때, 패드 스프링 설치 배율의 기본값을 설정합니다.",
    data: {
      min: 0.0,
      max: 200,
      step: 0.1,
      unit: CONST.UNIT_PERCENT,
      prefix: "",
      desc: "",
    },
  },
  padSpringMultFactor4: {
    label: "패드 스프링 설치 배율(%) [피복 4겹이상]",
    desc: "피복이 4겹이상 일때, 패드 스프링 설치 배율의 기본값을 설정합니다.",
    data: {
      min: 0.0,
      max: 200,
      step: 0.1,
      unit: CONST.UNIT_PERCENT,
      prefix: "",
      desc: "",
    },
  },

  // 개폐 설계
  switcherProtectionRubberFlag: {
    label: "개폐기 보호고무",
    desc: "개폐기 파트에서 피복을 개폐 마찰로부터 보호하는 개폐기 보호고무를 사용할지 선택합니다.",
    items: [
      {
        text: "개폐기 보호고무 사용",
        value: true,
      },
      {
        text: "개폐기 보호고무 사용안함",
        value: false,
      },
    ],
  },
  slopClipFlag: {
    label: "기울기 클립",
    desc: "1중 지붕 치마 패드에 피복이 걸리지 않도록, 기울기 클립을 추가로 설치할지 선택합니다.",
    items: [
      {
        text: "기울기 클립 사용",
        value: true,
      },
      {
        text: "기울기 클립 사용안함",
        value: false,
      },
    ],
  },
  skirtCoverLayingDepth: {
    label: "치마 피복 매설 깊이",
    desc: "치마 피복이 측면이나 앞뒷면에 설치되어 땅에 매설되는 깊이를 설정합니다.",
    data: {
      min: 0.0,
      max: 1,
      step: 0.1,
      unit: CONST.UNIT_METER,
      prefix: "",
      desc: "",
    },
  },
  skirtVinylOneBurstFitFlag: {
    label: "치마 비닐 일타 설치",
    desc: "일타 치마 비닐을 설치할때, 비닐을 접혀진 상태 그대로 설치할지, 펴서 설치할지 선택합니다.",
    items: [
      {
        text: "접혀진 상태로 설치",
        value: true,
      },
      {
        text: "펴서 설치",
        value: false,
      },
    ],
  },

  // 추가 설계
  curtainColumnReplaceFlag: {
    label: "커튼 설치시 기둥 피복 및 개폐 대체",
    desc: "기둥에 커튼이 설치될 때, 기존의 기둥 피복과 개폐를 빼고 설치할지, 그대로 둔 상태에서 추가로 설치할지 선택합니다.",
    items: [
      {
        text: "빼고 설치하기",
        value: true,
      },
      {
        text: "추가로 설치하기",
        value: false,
      },
    ],
  },
  curtainCeilingOverlapWidth: {
    label: "천창 커튼이 겹치는 폭",
    desc: "천장에 커튼이 설치될때, 겹쳐서 설치하는 커튼 피복의 폭입니다.",
    data: {
      min: 0.0,
      max: 1,
      step: 0.1,
      unit: CONST.UNIT_METER,
      prefix: "",
      desc: "",
    },
  },

  // 견적
  unitPriceEditFlag: {
    label: "견적 단가 수정",
    desc: "견적 수정에서 단가를 직접 수정하게 할지, 못하게 할지 선택합니다.",
    items: [
      {
        text: "단가 수정 가능",
        value: true,
      },
      {
        text: "단가 수정 불가능",
        value: false,
      },
    ],
  },
  // buildingMisPriceRatePercent: {
  //   label: '공과잡비 비율',
  //   desc: '전체 설계 자재비에 대한 공과잡비의 백분율(%)입니다.',
  //   data: {
  //     min: 0.0,
  //     max: 10,
  //     step: 0.1,
  //     unit: CONST.UNIT_PERCENT,
  //     prefix: '',
  //     desc: '',
  //   },
  // },
  totalPriceRateFinalMinPercent: {
    label: "견적 최소 배율",
    desc: "단가 변경이나 할인 등으로 줄일 수 있는 최종 배율의 최소값(%)입니다.",
    data: {
      min: 0.0,
      max: 100,
      step: 0.1,
      unit: CONST.UNIT_PERCENT,
      prefix: "",
      desc: "",
    },
  },
  purposePipeFlag: {
    label: "파이프 용도별 구분",
    desc: "작업별 견적서에서 파이프를 용도별로 구분하여 견적할지 선택합니다.",
    items: [
      {
        text: "구분하기",
        value: true,
      },
      {
        text: "구분하지 않기",
        value: false,
      },
    ],
  },
  purposeNormalHolderFlag: {
    label: "일반 고정구 용도별 구분",
    desc: "작업별 견적서에서 일반고정구를 용도별로 구분하여 견적할지 선택합니다.",
    items: [
      {
        text: "구분하기",
        value: true,
      },
      {
        text: "구분하지 않기",
        value: false,
      },
    ],
  },

  // 규격 기본값
  defaultScrewFlag: {
    label: "나사 규격 초기화",
    desc: "설계를 최초로 만들때, 해당 규격으로 초기화를 할지 선택합니다.",
    items: [
      {
        text: "초기화하기",
        value: true,
      },
      {
        text: "초기화하지 않기",
        value: false,
      },
    ],
  },
  defaultScrewCrossNormal: {
    label: "나사 [십자, 일반]",
    desc: "",
    items: [],
  },
  defaultScrewCrossStainless: {
    label: "나사 [십자, 스텐레스]",
    desc: "",
    items: [],
  },
  defaultScrewHexagonNormal: {
    label: "나사 [육각, 일반]",
    desc: "",
    items: [],
  },
  defaultNormalPadFlag: {
    label: "일반 패드 규격 초기화",
    desc: "설계를 최초로 만들때, 해당 규격으로 초기화를 할지 선택합니다.",
    items: [
      {
        text: "초기화하기",
        value: true,
      },
      {
        text: "초기화하지 않기",
        value: false,
      },
    ],
  },
  defaultNormalPadColorIron: {
    label: "일반 패드 [칼라 철]",
    desc: "",
    items: [],
  },
  defaultNormalPadAluminum: {
    label: "일반 패드 [알루미늄]",
    desc: "",
    items: [],
  },
};

export const PREFERENCE: Preference = {
  id: null,
  addExtraShadenetLengthFlag: false,
  buildingMisPriceRate: null,
  cashmilonStyleOverlapLength: null,
  company: COMPANY,
  connectedPipeExtraLength: 1.0,
  connectedPipePinWorkedFlag: false,
  curtainCeilingOverlapWidth: null,
  curtainColumnReplaceFlag: false,
  defaultNormalPadAluminum: null,
  defaultNormalPadColorIron: null,
  defaultNormalPadFlag: false,
  defaultScrewCrossNormal: null,
  defaultScrewCrossStainless: null,
  defaultScrewFlag: false,
  defaultScrewHexagonNormal: null,
  designPreferenceDefaultSpecDTO: {
    normalPadAluminumSpecModels: [],
    normalPadColorIronSpecModels: [],
    normalPadSpecModels: [],
    screwCrossNormalSpecModels: [],
    screwCrossStainlessSpecModels: [],
    screwHexagonNormalSpecModels: [],
    screwSpecModels: [],
  },
  endpieceDiagonalTclampFlag: false,
  endpieceDiagonalTholderFlag: false,
  endpieceTholderFlag: false,
  extendFrontBackCoverFlag: false,
  floorGirthPrismColumnWeldingFlag: false,
  lastUpdate: undefined,
  lastUpdater: "",
  multiplyVinylWidthDecupleFlag: false,
  padSpringMultFactor1: null,
  padSpringMultFactor2: null,
  padSpringMultFactor3: null,
  padSpringMultFactor4: null,
  pinWorkedNormalPadColorIronFlag: false,
  pinWorkedNormalPadZincFlag: false,
  prismEndpieceWeldingFlag: false,
  purposeNormalHolderFlag: false,
  purposePipeFlag: false,
  reduceOpenedCoverWidthFlag: false,
  skirtCoverLayingDepth: null,
  skirtVinylOneBurstFitFlag: false,
  slopClipFlag: false,
  switcherProtectionRubberFlag: false,
  totalPriceRateFinalMin: null,
  unitPriceEditFlag: false,
};
